<template>
  <router-link
    :to="{
      name: 'offsetter-project-details',
      params: { id: project._id },
    }"
  >
    <v-card class="mx-auto">
      <div class="detail-overlay">
        <p>{{ project.description.substring(0, 100) }}...</p>
        <button>Read more</button>
      </div>
      <v-img
        class="white--text align-end my-image"
        height="200px"
        :src="project.file.split(',')[0]"
        lazy-src="https://picsum.photos/id/11/100/60"
      >
        <v-card-title class="tw-bg-black tw-opacity-50">{{
          project.name
        }}</v-card-title>
      </v-img>
      <v-card-text class="">
        <!-- <section>Description: {{ project.description }}</section> -->
        <!-- <section>
          <b>Total Carbon:</b> {{ project.carbon_reduction_capacity }}
        </section>
        <section><b>Carbon Balance:</b> {{ project.carbon_balance }}</section> -->
        <section><b>Price:</b> &#8358;{{ project.price }} NGN/TONNE</section>
      </v-card-text>
    </v-card>
  </router-link>
</template>

<script>
export default {
  props: ["project"],
  data() {
    return {};
  },
  computed: {
    reference() {
      let text = "";
      let possible =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

      for (let i = 0; i < 10; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));

      return text;
    },
  },
  methods: {
    callback: function (response) {
      console.log(response);
      // this.makePayment();
    },
    close: function () {
      console.log("Payment closed");
    },
  },
};
</script>

<style lang="css" scoped>
.my-image {
  background: rgba(1, 6, 12, 0.82);
  overflow: hidden;
  height: 100%;
  z-index: 2;
}

.detail-overlay {
  position: absolute;
  height: 100%;
  width: 100%;
  text-align: center;
  z-index: 100;
  background-color: #000;
  opacity: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0px 20px;
  transition: opacity 0.25s ease-in;
}

.detail-overlay:hover {
  opacity: 0.6;
}

.detail-overlay p {
  color: #fff;
}

.detail-overlay button {
  color: #fff;
  border: 1px solid #fff;
  padding: 5px;
  text-align: center;
  width: fit-content;
}
</style>
